import { createAction } from '@ngrx/store';

export const logOut = createAction('[Session] Logout');
export const logoutSuccess = createAction('[Session] Logout Success');
